var _g, _path, _path2, _rect, _rect2, _rect3, _rect4, _g2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsPreviewFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 739,
    viewBox: "0 0 535 739",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4228_95162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 523,
    height: 724,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 76H339V232C339 250.778 323.778 266 305 266H96C77.2223 266 62 250.778 62 232L62 76Z",
    fill: "#E4E7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 247C58.1 243 62.5 215.333 62 202L66 237.5C65.5 240 58.9 245.4 36.5 247Z",
    fill: "#E4E7EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 107,
    width: 203,
    height: 13,
    rx: 6.5,
    fill: "#D6D6D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 141,
    width: 164,
    height: 13,
    rx: 6.5,
    fill: "#D6D6D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 175,
    width: 181,
    height: 13,
    rx: 6.5,
    fill: "#D6D6D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 209,
    width: 218,
    height: 13,
    rx: 6.5,
    fill: "#D6D6D6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4228_95162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 523,
    height: 74,
    fill: "#EBEBEB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M453.87 41.1258H452.425L451.913 40.6318C453.706 38.546 454.785 35.8382 454.785 32.8925C454.785 26.3242 449.461 21 442.893 21C436.324 21 431 26.3242 431 32.8925C431 39.4608 436.324 44.785 442.893 44.785C445.838 44.785 448.546 43.7055 450.632 41.9125L451.126 42.4248V43.8702L460.274 53L463 50.2739L453.87 41.1258V41.1258ZM442.893 41.1258C438.337 41.1258 434.659 37.4483 434.659 32.8925C434.659 28.3368 438.337 24.6592 442.893 24.6592C447.448 24.6592 451.126 28.3368 451.126 32.8925C451.126 37.4483 447.448 41.1258 442.893 41.1258Z",
    fill: "#C8C8C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40H32",
    stroke: "#C8C8C8",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26L32 40.2188L45 54.4375",
    stroke: "#C8C8C8",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384.436 36.8489C386.996 41.88 391.12 45.9867 396.151 48.5644L400.062 44.6533C400.542 44.1733 401.253 44.0133 401.876 44.2267C403.867 44.8844 406.018 45.24 408.222 45.24C409.2 45.24 410 46.04 410 47.0178V53.2222C410 54.2 409.2 55 408.222 55C391.529 55 378 41.4711 378 24.7778C378 23.8 378.8 23 379.778 23H386C386.978 23 387.778 23.8 387.778 24.7778C387.778 27 388.133 29.1333 388.791 31.1244C388.987 31.7467 388.844 32.44 388.347 32.9378L384.436 36.8489Z",
    fill: "#C8C8C8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 27,
    r: 4,
    fill: "#C8C8C8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 39,
    r: 4,
    fill: "#C8C8C8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 51,
    r: 4,
    fill: "#C8C8C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4228_95162",
    x: 0,
    y: 3,
    width: 535,
    height: 736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4228_95162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4228_95162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4228_95162",
    x: 0,
    y: 0,
    width: 535,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4228_95162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4228_95162",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsPreviewFrame);
export default __webpack_public_path__ + "static/media/sms-preview-frame.a96b6b38dff3574d89f2e0bd48bede55.svg";
export { ForwardRef as ReactComponent };